module.exports = __webpack_public_path__ + "img/garden_active.d0ddf838.svg";